import { Trans } from '@lingui/react';
import styled from 'styled-components';
import { Button } from '@components/ButtonV2';
import { Flex } from '@components/layout/Grid';
import { useContext } from 'react';
import LanguageContext from '@lib/contexts/languageContext';

const Card = styled(Flex)`
  color: #243240;
  border-radius: 4px;
  background-color: #f0f5fb;

  & ~ .Live--LiveCard:nth-of-type(12n):last-of-type {
    display: none;
  }
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  margin: 0 0 10px;
`;

const Body = styled.p`
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: 0 0 10px;
`;

const SubTitle = styled.p`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  margin: 0 0 10px;
  opacity: 0.8;
`;

export const LiveClaimTrialCard = () => {
  const lang = useContext(LanguageContext);

  return (
    <Card
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      px={[10, 10, 20]}
      py={40}
    >
      {/*  */}
      <Title>
        <Trans id="live.listings.claim_trial_card.title" />
      </Title>
      <Body>
        <Trans id="live.listings.claim_trial_card.description" />
      </Body>
      <SubTitle>
        <Trans id="live.listings.claim_trial_card.description2" />
      </SubTitle>
      <Button href={`/${lang}/get-started/trial`}>
        <Trans id="live.listings.claim_trial_card.start_trial" />
      </Button>
    </Card>
  );
};
